<template>
   <div class="flex items-start gap-2">
       <CustomCheckbox v-model="agreed" :id="generatedId" :value="true"/>
       <p class="text-xs text-[#2D2D2D] font-medium leading-tight">
           Оставляя заявку, вы соглашаетесь с
           <a :href="route('privacyPolicy')" target="_blank"
              class="md:hover:text-navHoverColor font-bold underline transition">
               политикой конфиденциальности
           </a>
           на обработку персональных данных.
       </p>
   </div>
</template>

<script setup>
import CustomCheckbox from "@js/components/Input/CustomCheckbox.vue";
import {ref} from "vue";

const generatedId = `consent-${Math.random().toString(36).substr(2, 9)}`;
const agreed = ref([true]);
</script>
